module.exports = __webpack_public_path__ + "img/bussiness-item-5.c7d5ff2a.png";